export default function reportError(error) {
  // eslint-disable-next-line no-console
  console.log(error);
  return null;
}
